var map = {
	"./area_beijing.png": 86016,
	"./area_beijing_dark.png": 43000,
	"./area_chuanyu.png": 47281,
	"./area_chuanyu_dark.png": 15603,
	"./area_guangdong.png": 38980,
	"./area_guangdong_dark.png": 6562,
	"./area_jiangzhe.png": 45883,
	"./area_jiangzhe_dark.png": 3106,
	"./area_shanghai.png": 2148,
	"./area_shanghai_dark.png": 70475,
	"./area_total.png": 30135,
	"./area_total_dark.png": 71861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56996;